<template>
    <div class="location-div">
        <el-tabs v-model="activeName" @tab-click="tabClick" class="base-tabs" type="border-card">
            <el-tab-pane name="first" label="地理坐标(度数)">
                <div class="base-form-div">
                    <el-form size="mini" :rules="rules" :model="ruleForm" label-width="40px" ref="ruleForm_first">
                        <el-form-item label="经度" prop="lon">
                            <el-input v-model="ruleForm.lon"></el-input>
                        </el-form-item>
                        <el-form-item label="纬度" prop="lat">
                            <el-input v-model="ruleForm.lat"></el-input>
                        </el-form-item>
                        <el-form-item label="高程" prop="alt">
                            <el-input v-model="ruleForm.alt"></el-input>
                        </el-form-item>
                        <el-form-item label="贴地">
                            <el-switch active-text="(贴地后将忽略指定高程)" v-model="ruleForm.clamp">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane name="second" label="地理坐标(度分秒)">
                <div class="base-form-div form-line">
                    <el-form size="mini" :model="ruleForm" label-width="40px" ref="ruleForm_second">
                        <el-form-item label="经度">
                            <el-input v-model="ruleForm.lon_d">
                                <template slot="append">度</template>
                            </el-input>
                            <el-input v-model="ruleForm.lon_f">
                                <template slot="append">分</template>
                            </el-input>
                            <el-input v-model="ruleForm.lon_m">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="纬度">
                            <el-input v-model="ruleForm.lat_d">
                                <template slot="append">度</template>
                            </el-input>
                            <el-input v-model="ruleForm.lat_f">
                                <template slot="append">分</template>
                            </el-input>
                            <el-input v-model="ruleForm.lat_m">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="高程">
                            <el-input class="input-line" v-model="ruleForm.alt"></el-input>
                        </el-form-item>
                        <el-form-item label="贴地">
                            <el-switch active-text="(贴地后将忽略指定高程)" v-model="ruleForm.clamp">
                            </el-switch>
                        </el-form-item>
                    </el-form>
                </div>
            </el-tab-pane>
            <el-tab-pane name="third" label="平面坐标">
                <div class="base-form-div">
                    <el-form size="mini" :model="ruleForm" label-width="40px" ref="ruleForm_third">
                        <el-form-item label="分带">
                            <el-radio v-model="ruleForm.radio" label="3">三度带</el-radio>
                            <el-radio v-model="ruleForm.radio" label="6">六度带</el-radio>
                            <span class="text">CGCS2000</span>
                        </el-form-item>
                        <el-form-item label="X">
                            <el-input placeholder="八位，前俩位为带号" v-model="ruleForm.x"></el-input>
                        </el-form-item>
                        <el-form-item label="Y">
                            <el-input placeholder="七位" v-model="ruleForm.y"></el-input>
                        </el-form-item>
                        <el-form-item label="高程">
                            <el-input v-model="ruleForm.alt"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-tab-pane>

        </el-tabs>
        <div class="form-bottom">
            <el-button class="base-button" size="mini" type="primary" @click="location">坐标定位</el-button>
        </div>
    </div>
</template>

<script>
//https://epsg.io/102100.proj4
//proj4.defs("EPSG:4528","+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
export default {
    data() {

        function validateNumberFun(text) {
            var validateNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入' + text));
                } else {
                    if (isNaN(value)) {
                        callback(new Error(text + '必须为数值,不能是其他字符'));
                    }
                    callback();
                }
            };

            return validateNumber;
        }

        return {
            activeName: "first",
            ruleForm: {
                lon: "",
                lat: "",
                alt: "",
                lon_d: "",
                lon_f: "",
                lon_m: "",
                lat_d: "",
                lat_f: "",
                lat_m: "",
                clamp: true,
                radio: "3",
                x: "",
                y: ""
            },
            rules: {
                lon: [
                    { validator: validateNumberFun("经度"), trigger: 'blur' }
                ],
                lat: [
                    { validator: validateNumberFun("纬度"), trigger: 'blur' }
                ],
                alt: [
                    { validator: validateNumberFun("高程"), trigger: 'blur' }
                ],
            },
            preOptions: {}
        };
    },

    mounted() {

        this.proj4_6();
        this.proj4_3();

        //CGCS2000地理坐标系
        proj4.defs("EPSG:4512", "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");//72
        proj4.defs("EPSG:4534", "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");//137
        proj4.defs("EPSG:4490", "+proj=longlat +ellps=GRS80 +no_defs +type=crs");

        //WGS84地理坐标系
        proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs +type=crs");

        //常规CGCS2000投影坐标系
        proj4.defs("EPSG:2435", "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=31.4,-144.3,-74.8,0,0,0.814,-0.38 +units=m +no_defs +type=crs");

        // const zoneNumber = this.bandNumberCalculation(116.4074, 3); // 使用6度分带方式，北京的经度为116.4074
        // console.log(zoneNumber);
        // 中央子午线投影为X轴，赤道投影为Y轴 (横轴是Y,纵轴是X)
        // 我国规定将各带纵坐标轴西移500公里，即将所有y值加上500公里，
        // 坐标值前再加各带带号，以18带为例，原坐标值为y=243353.5m，
        // 西移后为y=743353.5，加带号通用坐标为y=18743353.5。
        //在3度带的高斯投影实际使用时，为了保证坐标数值为正数，故将所有Y坐标值加上500km，即500000m，并将带号标于Y坐标值前，从而在计算上与原坐标相差39000000。

        //中国领土南北跨越纬度近50度，南北距离约为5500公里，东西跨经度有60多度，东西距离约5200公里

        //高斯投影的特点是：在长度和面积上变形很小，中央经线无变形，自中央经线向投影带边缘，变形逐渐增加，变形最大之处在投影带内赤道的两端。
    },

    beforeDestroy() {
        var entity = DBentityCollection.getById("坐标定位标识");
        if (entity) {
            entity.show = false;
        }
    },

    methods: {
        location() {
            var formName = "ruleForm_" + this.activeName;
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    var pos = {};
                    pos.type = this.activeName;
                    switch (this.activeName) {
                        case "first":
                            pos.lon = this.ruleForm.lon;
                            pos.lat = this.ruleForm.lat;
                            pos.alt = this.ruleForm.alt;
                            break;
                        case "second":
                            pos.lon = this.toDigital(this.ruleForm.lon_d, this.ruleForm.lon_f, this.ruleForm.lon_m);
                            pos.lat = this.toDigital(this.ruleForm.lat_d, this.ruleForm.lat_f, this.ruleForm.lat_m);
                            pos.alt = this.ruleForm.alt;
                            break;

                        case "third":
                            let zoneNumber = (this.ruleForm.x + "").slice(0, 2);
                            var wkid = this.getWKID(this.ruleForm.radio, zoneNumber);
                            const xy = proj4(wkid, 'EPSG:4326', [Number(this.ruleForm.x), Number(this.ruleForm.y)]);
                            this.ruleForm.lon = xy[0].toFixed(6);
                            this.ruleForm.lat = xy[1].toFixed(6);

                            pos.lon = this.ruleForm.lon;
                            pos.lat = this.ruleForm.lat;
                            pos.alt = this.ruleForm.alt;
                            break;

                        default:
                            break;
                    }
                    this.updateBillboard(pos.lon, pos.lat, pos.alt, this.ruleForm.clamp);
                    this.flyTo(pos.lon, pos.lat, pos.alt);
                    this.preOptions = pos;

                } else {
                    return false;
                }
            });
        },
        flyTo(lon, lat, alt) {
            alt = alt || 0;
            viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(lon, lat, alt + 10000.0)
            });
        },
        updateBillboard(lon, lat, alt, ground) {
            var p = Cesium.Cartesian3.fromDegrees(lon, lat, alt);
            var entity = DBentityCollection.getById("坐标定位标识");
            if (!entity) {
                entity = this.createBillboardEntity(p, "坐标定位标识");
                DBentityCollection.add(entity);
            }
            entity.billboard.heightReference = Cesium.HeightReference.NONE;
            if (ground) {
                entity.billboard.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
            }
            entity.show = true;;
            entity.position.setValue(p);
        },
        createBillboardEntity(center, id) {
            const entity = new Cesium.Entity({
                id: id,
                position: center,
                billboard: {
                    image: "data/img/marker/mark2.png",
                    scale: 1.0,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    heightReference: Cesium.HeightReference.NONE,
                },
            });
            return entity;
        },
        tabClick(tab) {
            console.log(tab.name);
            if (this.preOptions.type) {
                switch (this.activeName) {
                    case "first":
                        if (this.preOptions.type == "second") {
                            this.ruleForm.lon = this.toDigital(this.ruleForm.lon_d, this.ruleForm.lon_f, this.ruleForm.lon_m);
                            this.ruleForm.lat = this.toDigital(this.ruleForm.lat_d, this.ruleForm.lat_f, this.ruleForm.lat_m);
                        }
                        if (this.preOptions.type == "third") {
                            let zoneNumber = (this.ruleForm.x + "").slice(0, 2);
                            var wkid = this.getWKID(this.ruleForm.radio, zoneNumber);
                            const xy = proj4(wkid, 'EPSG:4326', [Number(this.ruleForm.x), Number(this.ruleForm.y)]);
                            this.ruleForm.lon = xy[0].toFixed(6);
                            this.ruleForm.lat = xy[1].toFixed(6);
                        }
                        break;
                    case "second":
                        if (this.preOptions.type == "first") {
                            var lon_arr = this.formatDegree(this.ruleForm.lon);
                            this.ruleForm.lon_d = lon_arr[0];
                            this.ruleForm.lon_f = lon_arr[1];
                            this.ruleForm.lon_m = lon_arr[2];

                            var lat_arr = this.formatDegree(this.ruleForm.lat);
                            this.ruleForm.lat_d = lat_arr[0];
                            this.ruleForm.lat_f = lat_arr[1];
                            this.ruleForm.lat_m = lat_arr[2];
                        }
                        if (this.preOptions.type == "third") {
                            let zoneNumber = (this.ruleForm.x + "").slice(0, 2);
                            var wkid = this.getWKID(this.ruleForm.radio, zoneNumber);
                            const xy = proj4(wkid, 'EPSG:4326', [Number(this.ruleForm.x), Number(this.ruleForm.y)]);
                            this.ruleForm.lon = xy[0].toFixed(6);
                            this.ruleForm.lat = xy[1].toFixed(6);

                            var lon_arr = this.formatDegree(this.ruleForm.lon);
                            this.ruleForm.lon_d = lon_arr[0];
                            this.ruleForm.lon_f = lon_arr[1];
                            this.ruleForm.lon_m = lon_arr[2];

                            var lat_arr = this.formatDegree(this.ruleForm.lat);
                            this.ruleForm.lat_d = lat_arr[0];
                            this.ruleForm.lat_f = lat_arr[1];
                            this.ruleForm.lat_m = lat_arr[2];
                        }
                        break;

                    case "third":
                        if (this.preOptions.type == "first") {
                            const zoneNumber = this.bandNumberCalculation(this.ruleForm.lon, this.ruleForm.radio); // 使用6度分带方式，北京的经度为116.4074
                            var wkid = this.getWKID(this.ruleForm.radio, zoneNumber);
                            const xy = proj4('EPSG:4326', wkid, [Number(this.ruleForm.lon), Number(this.ruleForm.lat)]);
                            this.ruleForm.x = xy[0].toFixed(2);
                            this.ruleForm.y = xy[1].toFixed(2);

                            // const xy2 = proj4('EPSG:4326', wkid, [Number(this.ruleForm.lon), Number(this.ruleForm.lat)]);
                            // console.log(xy2);
                        }
                        if (this.preOptions.type == "second") {
                            this.ruleForm.lon = this.toDigital(this.ruleForm.lon_d, this.ruleForm.lon_f, this.ruleForm.lon_m);
                            this.ruleForm.lat = this.toDigital(this.ruleForm.lat_d, this.ruleForm.lat_f, this.ruleForm.lat_m);

                            const zoneNumber = this.bandNumberCalculation(this.ruleForm.lon, this.ruleForm.radio); // 使用6度分带方式，北京的经度为116.4074
                            var wkid = this.getWKID(this.ruleForm.radio, zoneNumber);
                            const xy = proj4('EPSG:4326', wkid, [Number(this.ruleForm.lon), Number(this.ruleForm.lat)]);
                            this.ruleForm.x = xy[0].toFixed(2);
                            this.ruleForm.y = xy[1].toFixed(2);
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        formatDegree(value) {
            value = Math.abs(value);
            var v1 = Math.floor(value); //度  
            var v2 = Math.floor((value - v1) * 60); //分  
            var v3 = Math.round((value - v1) * 3600 % 60); //秒  
            return [v1, v2, v3];
        },
        toDigital(strDu, strFen, strMiao, len) {
            len = (len > 6 || typeof (len) == "undefined") ? 6 : len;//精确到小数点后最多六位   
            strDu = (typeof (strDu) == "undefined" || strDu == "") ? 0 : parseFloat(strDu);
            strFen = (typeof (strFen) == "undefined" || strFen == "") ? 0 : parseFloat(strFen) / 60;
            strMiao = (typeof (strMiao) == "undefined" || strMiao == "") ? 0 : parseFloat(strMiao) / 3600;
            var digital = strDu + strFen + strMiao;
            if (digital == 0) {
                return "";
            } else {
                return digital.toFixed(len);
            }
        },
        out_of_china(lng, lat) {
            return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false;
        },
        //24号带—45号带
        proj4_3() {
            var baseLon = 75;
            var baseX = 25500000;
            for (let i = 4513; i <= 4533; i++) {
                var lon = baseLon + (i - 4513) * 3;
                var x = baseX + (i - 4513) * 1000000;
                var wkid = `EPSG:${i}`;
                var proj4_Str = `+proj=tmerc +lat_0=0 +lon_0=${lon} +k=1 +x_0=${x} +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs`;
                // console.log(wkid);
                // console.log(proj4_Str);
                proj4.defs(wkid, proj4_Str);
            }
        },
        //13号带—23号带
        proj4_6() {
            var baseLon = 75;
            var baseX = 13500000;
            for (let i = 4491; i <= 4501; i++) {
                var lon = baseLon + (i - 4491) * 6;
                var x = baseX + (i - 4491) * 1000000;
                var wkid = `EPSG:${i}`;
                var proj4_Str = `+proj=tmerc +lat_0=0 +lon_0=${lon} +k=1 +x_0=${x} +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs`;
                // console.log(wkid);
                // console.log(proj4_Str);
                proj4.defs(wkid, proj4_Str);
            }
        },
        //根据经度计算出带号
        bandNumberCalculation(long, projectedBandWidth) {
            var num = 0;
            if (long <= 180) {
                if (projectedBandWidth == 6) {
                    num = Math.floor(long / projectedBandWidth) + 1;
                    //13号带—23
                    if (num < 13 || num > 23) {
                        num = 0;
                    }
                } else if (projectedBandWidth == 3) {
                    num = Math.floor((long - 1.5) / projectedBandWidth) + 1;
                    if (num < 24 || num > 45) {
                        num = 0;
                    }
                } else {
                    num = 0;
                }
            }
            return num;
        },
        /**
         * 计算中央经线
         * @param {*} lon 输入 用户输入的经度
         * @param {*} projectedBandWidth  输入 用户定义的投影带宽度
         * @returns {lon}  返回 中央经线
         */
        lonCalculation(lon, projectedBandWidth) {
            var num = this.bandNumberCalculation(lon, projectedBandWidth);
            var lon;
            if (projectedBandWidth === 6) {
                lon = num * 6 - 3;
            } else if (projectedBandWidth === 3) {
                lon = num * 3;
            }
            return lon;
        },
        //https://blog.csdn.net/fmechina/article/details/105513589
        getWKID(type, zone) {
            zone = Number(zone);
            if (zone == 0 || zone < 0) {
                return "EPSG:2435";
            }
            var id;
            //19500000
            if (type == "6") {
                if (zone < 13 || zone > 23) {
                    return "EPSG:2435";
                }
                //6度+带号
                // "CGCS2000_zone_6_13": "4491",
                //proj4.defs("EPSG:4491","+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
                // "CGCS2000_zone_6_14": "4492",
                //proj4.defs("EPSG:4492","+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
                // "CGCS2000_zone_6_15": "4493",
                //proj4.defs("EPSG:4493","+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
                // "CGCS2000_zone_6_16": "4494",
                // "CGCS2000_zone_6_17": "4495",
                // "CGCS2000_zone_6_18": "4496",
                // "CGCS2000_zone_6_19": "4497",
                // "CGCS2000_zone_6_20": "4498",
                // "CGCS2000_zone_6_21": "4499",
                // "CGCS2000_zone_6_22": "4500",
                // "CGCS2000_zone_6_23": "4501",
                id = 4478 + zone;// 有带号&北半球
            }
            //37500000
            if (type == "3") {
                if (zone < 24 || zone > 45) {
                    return "EPSG:2435";
                }
                // 3度+带号
                // "CGCS2000_zone_3_25": "4513",
                //proj4.defs("EPSG:4513","+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
                // "CGCS2000_zone_3_26": "4514",
                //proj4.defs("EPSG:4514","+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs +type=crs");
                // "CGCS2000_zone_3_27": "4515",
                // "CGCS2000_zone_3_28": "4516",
                // "CGCS2000_zone_3_29": "4517",
                // "CGCS2000_zone_3_30": "4518",
                // "CGCS2000_zone_3_31": "4519",
                // "CGCS2000_zone_3_32": "4520",
                // "CGCS2000_zone_3_33": "4521",
                // "CGCS2000_zone_3_34": "4522",
                // "CGCS2000_zone_3_35": "4523",
                // "CGCS2000_zone_3_36": "4524",
                // "CGCS2000_zone_3_37": "4525",
                // "CGCS2000_zone_3_38": "4526",
                // "CGCS2000_zone_3_39": "4527",
                // "CGCS2000_zone_3_40": "4528",
                // "CGCS2000_zone_3_41": "4529",
                // "CGCS2000_zone_3_42": "4530",
                // "CGCS2000_zone_3_43": "4531",
                // "CGCS2000_zone_3_44": "4532",
                // "CGCS2000_zone_3_45": "4533",
                id = 4488 + zone;// 有带号&北半球
            }

            return `EPSG:${id}`

        },
        proj4Demo() {
            // 引入proj4js库
            // const proj4 = require('proj4');

            // // 定义坐标系
            // proj4.defs('EPSG:4490', '+proj=longlat +ellps=GRS80 +no_defs');
            // proj4.defs('EPSG:2435', '+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +units=m +no_defs');

            // // 定义经纬度坐标
            // const lng = 116.4074;
            // const lat = 39.9042;

            // // 将经纬度坐标转换为平面坐标
            // const xy = proj4('EPSG:4490', 'EPSG:2435', [lng, lat]);

            // // 输出平面坐标
            // console.log(xy);
        }
    },
};
</script>

<style lang="scss">
.form-line {
    .el-input {
        width: 88px;
        margin-right: 2px;

        .el-input-group__append {
            width: 30px;
            padding: 0;
            text-align: center;
            border: none;
            color: #fff;
            background-color: transparent;
        }
    }

    .input-line {
        width: 260px;
    }
}

.location-div {
    .form-bottom {
        text-align: center;
    }

    .el-switch__label {
        color: #ffffff;
    }

    .text {
        color: #fff;
    }
}
</style>